<template>
  <v-card>
    <v-container>
      <v-skeleton-loader
        :loading="skeleton"
        class="mx-auto"
        type="card-heading, list-item-two-line"
      >
        <v-row>
          <v-col>
            <v-icon> mdi-clock </v-icon>
            <span class="headline mx-2">Away</span>
          </v-col>
        </v-row>

        <v-hover v-slot:default="{ hover }">
          <v-row>
            <v-col>
              <span class="font-weight-medium">Temporary Away: </span>
              <span
                v-if="typeof(employeeTimeClock) ==='object'"
                class="error--text text--darken-2"
              >
                Yes
              </span>
              <span
                v-else
                class="success--text text--darken-2"
              >
                No
              </span>

              <span v-if="$hasPermissionTo(['update time clock'])">
                <span v-show="hover">
                    
                  <employee-time-clocks-dialog-edit
                    v-if="typeof(employeeTimeClock) ==='object'"
                    :employee-uid="employeeUid"
                    :clocktime="employeeTimeClock"
                    @updated="loadTimeClock"
                  />

                  <employee-time-clocks-dialog-create
                    v-else
                    :employee-uid="employeeUid"
                    @created="loadTimeClock"
                  />
                </span>
              </span>
            </v-col>
          </v-row>
        </v-hover>
      </v-skeleton-loader>
    </v-container>     
  </v-card>
</template>

<script>
  export default {
    components: {
      EmployeeTimeClocksDialogEdit: () => import('@/components/employee/timeclocks/DialogEdit'),
      EmployeeTimeClocksDialogCreate: () => import('@/components/employee/timeclocks/DialogCreate'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },    
    },
    data () {
      return {
        skeleton: true,
        employeeTimeClock: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadTimeClock()
          }
        },
      },
    },
    methods: {  
      loadTimeClock () {
        this.$api.timeClocks().show(this.employeeUid)
          .then((res) => {
            this.employeeTimeClock = res.data
            this.skeleton = false
          })
      },
    },
  }
</script>

<style lang="css" scoped>
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }
.v-btn.custom-btn:hover{
  box-shadow: 2px 5px 15px 2px rgba(0, 0, 0, 0.267);
  transform: none;
}

</style>
